import { useCallback, memo, useState } from 'react';
import { autoUpdate, flip, offset, shift, useFloating } from '@floating-ui/react';
import FormatColorTextIcon from '@mui/icons-material/FormatColorText';
import { ClickAwayListener } from '@mui/material';
import { GithubPicker } from 'react-color';
import { useTextColorCommands } from './hooks/useTextColorCommands';
import { ToolbarButton } from './Toolbar.Button';

export const ColorButton = () => {
  const [isPickerOpen, setIsPickerOpen] = useState(false);

  const { refs, floatingStyles } = useFloating({
    open: isPickerOpen,
    placement: 'bottom-start',
    middleware: [offset(4), flip(), shift()],
    whileElementsMounted: autoUpdate,
  });

  const { activeColor, setTextColor: setTextColorCommand } = useTextColorCommands();

  const handleClickAway = useCallback(() => {
    setIsPickerOpen(false);
  }, []);

  const setTextColor = useCallback((color: string) => {
    setTextColorCommand(color);
    setIsPickerOpen(false);
  }, [setTextColorCommand]);

  return (
    <>
      <ToolbarButton ref={refs.setReference} onClick={() => setIsPickerOpen(true)}>
        <ColorIcon color={activeColor} />
      </ToolbarButton>
      {isPickerOpen && (
        <ClickAwayListener onClickAway={handleClickAway}>
          <div
            ref={refs.setFloating}
            style={floatingStyles}
          >
            <div>
              <ColorPopperContent color={activeColor} onChange={setTextColor} />
            </div>
          </div>
        </ClickAwayListener>
      )}
    </>
  );
};

const ColorIcon = memo(({ color }: { color: string }) => {
  return (
    <>
      <FormatColorTextIcon htmlColor={color} />
    </>
  );
});

const GITHUB_COLORS = ['#B80000', '#DB3E00', '#FCCB00', '#008B02', '#006B76', '#1273DE', '#004DCF', '#5300EB', '#000000', '#EB9694', '#FAD0C3', '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6', '#BED3F3', '#D4C4FB', '#FFFFFF'];

const GitHubPickerContent = (props: ColorProps) => {
  return (
    <GithubPicker
      colors={GITHUB_COLORS}
      width={'225px'}
      color={props.color}
      onChange={e => props.onChange(e.hex)}
      triangle='hide' />
  );
};

type ColorProps = {
  color: string;
  onChange: (color: string) => void;
};

const ColorPopperContent = (props: ColorProps) => {
  return <GitHubPickerContent {...props} />;
};